import { Injectable, signal } from '@angular/core';
import {DrawnCard} from '@/app/core/models/collection/drawn-card.model';

export type BoosterState = 'idle' | 'video' | 'done';

@Injectable({ providedIn: 'root' })
export class BoosterStateService {
	readonly state = signal<BoosterState>('idle');
	readonly cards = signal<DrawnCard[]>([]);

	open(): void     { this.state.set('video'); }
	markDone(): void { this.state.set('done'); }
	close(): void    { this.state.set('idle'); }

	setCards(cards: DrawnCard[]): void { this.cards.set(cards); }
}
